import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import PackWidget from 'components/PackWidget';
import LinkHeading from 'components/LinkHeading';
import NoNextPackWidget from 'components/NoNextPackWidget';
import TextLink from 'components/TextLink';

const StyledOverviewOrdersView = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing * 6}px;
  .PackWidget,
  .NoNextPackWidget {
    margin-bottom: ${({ theme }) => theme.spacing * 2}px;
  }
`;

const OverviewOrdersView = ({
  className,
  nextPack,
  previousPack,
}) => {
  const classes = ['OverviewOrdersWidget'];

  if (className) classes.push(className);

  return (
    <StyledOverviewOrdersView className={classes.filter((c) => !!c).join(' ')}>
      <LinkHeading
        title="Orders"
        rightElement={<TextLink props={{ to: '/orders' }}>See all orders</TextLink>}
      />
      {nextPack ? (
        <PackWidget
          className="nextPack"
          pack={nextPack}
          showPayments
        />
      ) : (
        previousPack && <NoNextPackWidget previousPack={previousPack} />
      )}

      {previousPack && (
        <PackWidget
          className="previousPack"
          pack={previousPack}
          hideBottomSection
          smallCTA
        />
      )}
    </StyledOverviewOrdersView>
  );
};

OverviewOrdersView.displayName = 'OverviewOrdersView';

OverviewOrdersView.propTypes = {
  className: PropTypes.string,
  nextPack: PropTypes.shape({}),
  previousPack: PropTypes.shape({}),
};

OverviewOrdersView.defaultProps = {
  className: null,
  nextPack: null,
  previousPack: null,
};

export default OverviewOrdersView;
